// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"welcome_wrapper__1VZUT","home-section":"welcome_home-section__yS7cC","footer":"welcome_footer__NOY3V"};